import { jsx as _jsx } from "react/jsx-runtime";
import { LinkVariants, LinkWeights } from "./constants";
import StyledLink from "./Link.style";
const Link = ({ children, href = "", variant = LinkVariants.link_1, weight = LinkWeights.regular, ...props }) => (_jsx(StyledLink, { href: href, variant: variant, weight: weight, ...props, children: children }));
export default Link;
//# sourceMappingURL=Link.js.map